module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-6.b9c97c0e.jpg";